const PREFIX = "pim:";
export class PrefixIriProvider {
    cimToPim(cimIri) {
        return PREFIX + cimIri;
    }
    pimToCim(pimIri) {
        if (!pimIri.startsWith(PREFIX)) {
            throw new Error(`Unable to convert PIM iri ${pimIri} to CIM iri.` +
                `Expected ${PREFIX} prefix.`);
        }
        return pimIri.substr(PREFIX.length);
    }
}
//# sourceMappingURL=prefix-iri-provider.js.map